import { render, staticRenderFns } from "./TaskInfoCard.vue?vue&type=template&id=98f9acb4&scoped=true&"
import script from "./TaskInfoCard.vue?vue&type=script&lang=js&"
export * from "./TaskInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./TaskInfoCard.vue?vue&type=style&index=0&id=98f9acb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f9acb4",
  null
  
)

export default component.exports